import { Instance, SnapshotIn, types } from 'mobx-state-tree';
import { ChartTab, ChartTabProps } from './chart-tab/chart-tab';
import { SingleBar, SingleBarProps } from './single-bar/single-bar';

export interface DashboardSingleChartProps {
  name: string;
  tab: ChartTabProps;
  chart: SingleBarProps[];
}

export const DashboardSingleChart = types.model({
  name: types.string,
  tab: ChartTab,
  chart: types.optional(types.array(SingleBar), []),
});

export type DashboardSingleChartSnapshot = SnapshotIn<
  typeof DashboardSingleChart
>;
export type DashboardSingleChartInstance = Instance<
  typeof DashboardSingleChart
>;
